import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  FormControl,
  InputGroupText,
  FormGroup,
  Table,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

import TableContainer from "../../../Components/Common/TableContainer";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../Components/Common/Loader";

// Export Modal
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { useReactTable } from "@tanstack/react-table";
import axios from "axios";
import { fetchCategories, fetchImages } from "../../../lib/Apis";
import AddChoiceModal from "../../../Components/Common/ChoiceModal";
import axiosInstance from "../../../lib/AxiosInstance";

const Categories = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTranslation, setIsTranslation] = useState(false);
  const [translations, setTranslations] = useState([]);
  const [catName, setCatName] = useState("");
  const [catNameError, setCatNameError] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState("");
  const [locale, setLocale] = useState([]);
  const [translationLocaleError, setTranslationLocaleError] = useState(false);
  const [selectedTranId, setSelectedTranId] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [navModal, setNavModal] = useState(false);
  const limit = 10;
  // const [customerList, setcustomerList] = useState([]);

  // Delete customer
  const fileInputRef = useRef(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const [modal, setModal] = useState(false);
  const [addModal, setAddModal] = useState(false);

  const toggle = useCallback(
    (arg) => {
      if (modal || addModal) {
        setModal(false);
        setSelectedCategory(null);
        setSelectedId("");
        setAddModal(false);
        setTranslations([]);
        setIsTranslation(false);
        setSelectedImage(null);
      } else if (arg === "add") {
        setAddModal(true);
      } else {
        setModal(true);
      }
    },
    [modal, addModal]
  );

  const token = sessionStorage.getItem("token");

  console.log(token);
  

  const {
    data: categories = [],
    isLoading: categoriesLoading = false,
    isError,
    error: categoriesError = false,
  } = useQuery({
    queryKey: ["categories", page, limit, searchTerm],
    queryFn: () => fetchCategories(page, limit, searchTerm),
    enabled: !!token,
  });

  const categoriesData = categories?.data ?? [];

  const totalPages = categories?.totalPages;

  const {
    data: images = [],
    isLoading: imagesLoading = false,
    error: imagesError = false,
  } = useQuery({
    queryKey: ["images"],
    queryFn: () => fetchImages(),
    enabled: !!addModal || !!modal,
  });

  const imagesData = images?.data ?? [];

  //   const {
  //     data: singleBrand = [],
  //     isLoading: singleBrandLoading = false,
  //     error: singleBrandError = false,
  //   } = useQuery({
  //     queryKey: ["singleBrand", selectedId],
  //     queryFn: () => fetchSingleBrand(selectedId),
  //     enabled: !!selectedId,
  //   });

  //   const singleBrandData = singleBrand?.data ?? [];

  //   useEffect(() => {
  //     if (singleBrand?.data) {
  //       setTranslations(singleBrand?.data?.translations ?? []);
  //     }
  //   }, [singleBrand?.data?.id]);

  //   const {
  //     data: translation = [],
  //     isLoading: translationsLoading = false,
  //     isError: isTranslationError = false,
  //     error: translationsError = false,
  //   } = useQuery({
  //     queryKey: ["translations"],
  //     queryFn: () => fetchTranslations(),
  //   });

  //   let translationsData = translation?.data ?? [];
  const translationsData = [
    {
      locale: "en",
      name: "Beverages",
    },
    {
      locale: "fr",
      name: "Boissons",
    },
    {
      locale: "es",
      name: "Bebidas",
    },
    {
      locale: "de",
      name: "Getränke",
    },
  ];

  const updateCategoryMutation = useMutation({
    mutationFn: async (credentials) => {
      const token = sessionStorage.getItem("token");

      const { data } = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/category/${selectedId}`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      toast.success("Category Updated !");
      toggle();
      validation.resetForm();
      queryClient.invalidateQueries(["categories"]);
      validation.setSubmitting(false);
    },
    onError: (error) => {
      toast.error("Category updating failed !");
      validation.setSubmitting(false);
    },
  });

  const addCategoryMutation = useMutation({
  mutationFn: async (credentials) => {
    try {
      const token = sessionStorage.getItem("token");

      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_BASE_URL}/category/create`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return data;
    } catch (error) {
      
      throw error.response?.data || error;
    }
  },

  onSuccess: (data) => {
    toast.success("Added new Category");
    toggle();
    validation.resetForm();
    queryClient.invalidateQueries(["categories"]);
    validation.setSubmitting(false);
  },

  onError: (error) => {
   

    toast.error(error?.message);
    validation.setSubmitting(false);
  },
});


  const categoryStatusMutation = useMutation({
    mutationFn: async (credentials) => {

      const token = sessionStorage.getItem("token");

      const { data } = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/category/${credentials.id}/status`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["categories"]);
    },
    onError: (error) => {
      toast.error("Category status updating failed !");
    },
  });

  const deleteCategoryMutation = useMutation({
    mutationFn: async (credentials) => {
      const token = sessionStorage.getItem("token");

      const { data } = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/category/${selectedId}/delete`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["categories"]);
      setDeleteModal(false);
    },
    onError: (error) => {
      toast.error("Category deletion failed !");
    },
  });

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      category_name: selectedCategory?.category_name || "",
      category_image: selectedCategory?.category_image || null,
    },

    validationSchema: Yup.object({
      category_name: Yup.string().required("Please Enter Category Name"),
      category_image: Yup.mixed()
        .nullable()
        .test("imageTest", "Validation error", async function (value) {
          const createError = (msg) => this.createError({ message: msg });

          // Skip validation entirely if no image is uploaded
          if (!value) return true;

          // Helper to check image dimensions
          const checkImageDimensions = (file) =>
            new Promise((resolve) => {
              const img = new Image();
              img.onload = () => {
                if (img.width !== 424 || img.height !== 320) {
                  resolve(
                    createError(
                      "Image dimensions must be exactly 424x320 pixels"
                    )
                  );
                } else resolve(true);
              };
              img.onerror = () => resolve(createError("Invalid image file"));
              img.src = URL.createObjectURL(file);
            });

          // Validate if it's a File (not an existing URL)
          if (value instanceof File) {
            if (!["image/jpeg", "image/png", "image/jpg"].includes(value.type))
              return createError("Only .jpg, .jpeg, .png files are allowed");

            if (value.size > 2 * 1024 * 1024)
              return createError("File size is too large (max 2MB)");

            return await checkImageDimensions(value);
          }

          return true;
        }),
    }),

    onSubmit: (values) => {
      const formData = new FormData();

      // Append common fields
      formData.append("name", values.category_name);

      if (isEdit) {
        formData.append("image", selectedImage || values.category_image);
      } else {
        formData.append("image", values.category_image);
      }
      if (!isEdit) {
        formData.append("imageurl", selectedImage);
      }

      if (translations.length > 0) {
        formData.append("translations", JSON.stringify(translations));
      }

      if (isEdit && (selectedImage || values.category_image)) {
        formData.append("id", selectedCategory ? selectedCategory.id : 0);
        updateCategoryMutation.mutate(formData);
      } else if (selectedImage || values.category_image) {
        addCategoryMutation.mutate(formData);
      } else {
        toast.error("Any image is mandatory");
        validation.setSubmitting(false);
      }
    },
  });

  const newId = () => {
    return Math.floor(Math.random() * 1000000) + Date.now();
  };

  const saveTranslation = () => {
    let hasError = false;

    if (catName === "") {
      setCatNameError(true);
      hasError = true;
    } else {
      setCatNameError(false);
    }

    if (selectedLocale === "") {
      setTranslationLocaleError(true);
      hasError = true;
    } else {
      setTranslationLocaleError(false);
    }

    if (hasError) return;

    // Add or update translation
    setTranslations((prev) => {
      if (selectedTranId) {
        // Edit existing
        return prev.map((t) =>
          t.id === selectedTranId
            ? {
                ...t,
                locale: selectedLocale,
                category_name: catName,
              }
            : t
        );
      } else {
        // Add new
        const id = newId();
        return [
          ...prev,
          {
            id,
            locale: selectedLocale,
            category_name: catName,
          },
        ];
      }
    });

    // Clear inputs after successful save
    setCatName("");
    setSelectedLocale("");
    setSelectedTranId(null);
  };

  const handleToggle = async (id, status) => {
    const newStatus = status === 0 ? 1 : 0;

    categoryStatusMutation.mutate({ id, status: newStatus });
  };

 

  // Update Data
  const handleCategoryClick = useCallback(
    (arg) => {
      const category = arg;
      setSelectedId(category?._id);

      setSelectedCategory({
        id: category._id,
        category_image: category.image,
        category_name: category.name,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const onDelete = (id) => {
    setTranslations((prev) => prev.filter((t) => t.id !== id));
  };

  // Add Data
  const onClickDelete = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  useEffect(() => {
    const filteredTranslations = translationsData.filter(
      (item) => !translations.some((t) => t.locale === item.name)
    );

    setLocale(filteredTranslations);
  }, [isTranslation, translations]);
  const brandsLoading = false;
  const brandsError = false;

  // Customers Column
  const columns = useMemo(
    () => [
      {
        header: "Category Name",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Image",
        accessorKey: "image",
        enableColumnFilter: false,
        cell: ({ row }) => {
          const imageUrl = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${row.original.image}`;

          return (
            <div className="d-flex align-items-center gap-2">
              <img
                src={imageUrl}
                alt="Product"
                className="rounded-circle"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
              />
            </div>
          );
        },
      },

      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        cell: (cell) => {
          const value = cell.getValue(); // this will be 0 or 1
          if (value === 0) {
            return (
              <span className="badge text-uppercase bg-success-subtle text-success">
                Active
              </span>
            );
          } else if (value === 1) {
            return (
              <span className="badge text-uppercase bg-danger-subtle text-danger">
                Inactive
              </span>
            );
          } else {
            return (
              <span className="badge text-uppercase bg-info-subtle text-info">
                Unknown
              </span>
            );
          }
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              {cellProps.row.original.level === 1 ? (
                <li className="list-inline-item" title="Subcategories">
                  <button
                    type="button"
                    onClick={() => {
                      setNavModal(true);
                      setSelectedId(cellProps.row.original._id);
                    }}
                    className="text-primary d-inline-block edit-item-btn border-0 bg-transparent p-0"
                  >
                    <i className="mdi mdi-layers-triple-outline fs-16"></i>
                  </button>
                </li>
              ) : (
                <li className="list-inline-item" title="Subcategories">
                  <Link
                    to={
                      cellProps.row.original.level === 2
                        ? `/sub-categories?id=${cellProps.row.original._id}`
                        : cellProps.row.original.level === 0
                        ? `/products?id=${cellProps.row.original._id}`
                        : "#"
                    }
                    className="text-primary d-inline-block"
                  >
                    <i className="mdi mdi-layers-triple-outline fs-16"></i>
                  </Link>
                </li>
              )}

              <li className="list-inline-item edit" title="Edit">
                <button
                  type="button"
                  className="text-primary d-inline-block edit-item-btn border-0 bg-transparent p-0"
                  onClick={() => {
                    const brandsData = cellProps.row.original;
                    handleCategoryClick(brandsData);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </button>
              </li>
              <li className="list-inline-item toggle" title="Toggle Status">
                <FormGroup switch>
                  <Input
                    type="switch"
                    checked={cellProps.row.original.status === 0}
                    onChange={() =>
                      handleToggle(
                        cellProps.row.original._id,
                        cellProps.row.original.status
                      )
                    }
                  />
                </FormGroup>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const cateId = cellProps.row.original._id;
                    onClickDelete(cateId);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleCategoryClick]
  );

  const cloudFrontUrl = process.env.REACT_APP_CLOUD_FRONT_URL;

  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "Category | Brew Chew Menu Admin Panel";
  return (
    <React.Fragment>
      <div className="page-content">
        {/* <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={brandsData}
        /> */}

        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => deleteCategoryMutation.mutate({ isDeleted: 1 })}
          onCloseClick={() => setDeleteModal(false)}
        />
        <AddChoiceModal
          show={navModal}
          onCloseClick={() => setNavModal(false)}
          onAddProduct={() => navigate(`/products?id=${selectedId}`)}
          onAddSubCategory={() => navigate(`/sub-categories?id=${selectedId}`)}
        />

        <Container fluid>
          <BreadCrumb title="Categories List" pageTitle="Categories" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Categories List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-success add-btn"
                          id="create-btn"
                          onClick={() => {
                            setIsEdit(false);
                            toggle("add");
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                          Category
                        </button>

                        <Link
                          to="/category-sort"
                          type="button"
                          className="btn btn-primary add-btn"
                          id="create-btn"
                        >
                          <i className="ri-sort-asc align-bottom me-1"></i> Sort
                          Category
                        </Link>
                      </div>
                    </div>
                  </Row>
                  <Col sm={5}>
                    <InputGroup>
                      <InputGroupText>
                        <i className="bx bx-search-alt"></i>
                      </InputGroupText>
                      <Input
                        type="text"
                        placeholder="Search for category name..."
                        value={searchTerm ?? ""}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </CardHeader>

                <div className="card-body pt-0">
                  <div>
                    {categoriesLoading ? (
                      <Loader error={categoriesError} />
                    ) : categoriesData.length === 0 ? (
                      <div className="text-center py-4 text-muted">
                        No Datas found.
                      </div>
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={categoriesData}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        theadClass="table-light text-muted"
                      />
                    )}
                    <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
                      <div className="col-sm"></div>
                      <div className="col-sm-auto">
                        <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                          <li
                            className={`page-item ${
                              page <= 1 ? "disabled" : ""
                            }`}
                          >
                            <Button
                              
                              className="page-link"
                              onClick={() => {
                                if (page > 1) setPage(page - 1);
                              }}
                            >
                              Previous
                            </Button>
                          </li>

                          <li className="page-item">
                            <Link to="#" className="page-link active">
                              {page}
                            </Link>
                          </li>

                          <li
                            className={`page-item ${
                              page >= totalPages ? "disabled" : ""
                            }`}
                          >
                            <Button
                              className="page-link"
                              onClick={() => {
                                if (page < totalPages) setPage(page + 1);
                              }}
                            >
                              Next
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Row>
                  </div>

                  <Modal
                    id="showModal"
                    isOpen={modal || addModal}
                    toggle={toggle}
                    centered
                  >
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {modal ? "Edit Category Details" : "Add Category Details"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div
                          className="mb-3"
                          id="modal-id"
                          style={{ display: "none" }}
                        >
                          <Label htmlFor="id-field1" className="form-label">
                            ID
                          </Label>
                          <Input
                            type="text"
                            id="id-field1"
                            className="form-control"
                            placeholder="ID"
                            readOnly
                          />
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="category_name" className="form-label">
                            Category Name
                          </Label>
                          <Input
                            name="category_name"
                            id="category_name"
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.category_name || ""}
                            invalid={
                              validation.touched.category_name &&
                              validation.errors.category_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.category_name &&
                          validation.errors.category_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.category_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        {!validation.values.category_image && (
                          <Col className="mb-3">
                            <Col lg={9}>
                              <Label className="form-label">
                                Default Images
                              </Label>
                            </Col>

                            <Col lg={12}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between",
                                }}
                              >
                                {imagesData.length > 0 &&
                                  imagesData.map((data, index) => (
                                    <div
                                      key={index}
                                      onClick={() =>
                                        setSelectedImage((prev) =>
                                          prev === data.image
                                            ? null
                                            : data.image
                                        )
                                      } // toggle selection
                                      style={{
                                        position: "relative",
                                        flex: "0 0 100px",
                                        borderRadius: "8px",
                                        boxShadow:
                                          selectedImage === data.image
                                            ? "0 0 0 3px #007bff"
                                            : "0 4px 12px rgba(0, 0, 0, 0.15)",
                                        cursor: "pointer",
                                        overflow: "hidden",
                                        transition: "all 0.3s ease",
                                      }}
                                    >
                                      <img
                                        src={`${cloudFrontUrl}/${data?.image}`}
                                        alt="Preview"
                                        style={{
                                          width: "100%",
                                          height: "100px",
                                          objectFit: "contain",
                                          borderRadius: "8px",
                                          filter:
                                            selectedImage === data.image
                                              ? "brightness(0.9)"
                                              : "brightness(1)",
                                          transition: "filter 0.3s ease",
                                        }}
                                      />

                                      {selectedImage === data.image && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            inset: 0,
                                            background:
                                              "rgba(0, 123, 255, 0.4)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Selected
                                        </div>
                                      )}
                                    </div>
                                  ))}
                              </div>
                            </Col>
                          </Col>
                        )}
                        {!selectedImage && (
                          <Col className="mb-3">
                            <Col lg={9}>
                              <Label className="form-label">
                                Image( Upload Image with 424 X 320 pixel )
                              </Label>
                            </Col>

                            <Col lg={12}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "flex-start",
                                }}
                              >
                                {/* Upload section */}
                                <div
                                  style={{
                                    flex: validation.values.category_image
                                      ? "1 1 70%"
                                      : "1 1 100%",
                                    border: "2px dashed #ccc",
                                    padding: "20px",
                                    textAlign: "center",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    background: "#f8f8f8",
                                  }}
                                  onDragOver={(e) => e.preventDefault()}
                                  onDrop={(e) => {
                                    e.preventDefault();
                                    if (
                                      e.dataTransfer.files &&
                                      e.dataTransfer.files[0]
                                    ) {
                                      validation.setFieldValue(
                                        "category_image",
                                        e.dataTransfer.files[0]
                                      );
                                    }
                                  }}
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={(e) => {
                                      if (
                                        e.currentTarget.files &&
                                        e.currentTarget.files[0]
                                      ) {
                                        validation.setFieldValue(
                                          "category_image",
                                          e.currentTarget.files[0]
                                        );
                                      }
                                    }}
                                    style={{ display: "none" }}
                                  />
                                  <p className="mb-0">
                                    Drag & Drop your files or{" "}
                                    <span className="text-primary">Browse</span>
                                  </p>
                                  {validation.touched.category_image &&
                                    validation.errors.category_image && (
                                      <div className="text-danger mt-1">
                                        {validation.errors.category_image}
                                      </div>
                                    )}
                                </div>

                                {/* Preview section */}
                                {validation.values.category_image && (
                                  <div
                                    style={{
                                      position: "relative",
                                      flex: "0 0 100px",
                                      borderRadius: "8px",
                                      boxShadow:
                                        "0 4px 12px rgba(0, 0, 0, 0.15)",
                                    }}
                                  >
                                    <img
                                      src={
                                        validation.values
                                          .category_image instanceof File
                                          ? URL.createObjectURL(
                                              validation.values.category_image
                                            ) // For uploaded files
                                          : validation.values.category_image
                                          ? `${cloudFrontUrl}/${validation.values.category_image}` // For existing image URL
                                          : "" // fallback if no image
                                      }
                                      alt="Preview"
                                      style={{
                                        width: "100%",
                                        height: "100px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />

                                    <button
                                      type="button"
                                      onClick={() => {
                                        validation.setFieldValue(
                                          "category_image",
                                          null
                                        ); // clear Formik value
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: "-8px",
                                        right: "-8px",
                                        background: "red",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        textAlign: "center",
                                        padding: 0,
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Col>
                        )}

                        {/* <div className="d-flex justify-content-between align-items-center my-3">
                          <button
                            type="button"
                            className="btn btn-primary me-2"
                            onClick={() => setIsTranslation(true)}
                          >
                            Translations
                          </button>

                          {isTranslation && (
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={() => setIsTranslation(false)}
                            />
                          )}
                        </div> */}

                        {isTranslation && (
                          <>
                            {/* Translations Table */}
                            {translations.length > 0 && (
                              <Table
                                bordered
                                hover
                                responsive
                                className="align-middle"
                              >
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Locale</th>
                                    <th>Category Name</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {translations.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1}</td>
                                      <td>{item.locale}</td>
                                      <td>{item.category_name}</td>

                                      <td>
                                        <ul className="list-inline hstack gap-2 mb-0">
                                          {/* Edit */}
                                          <li
                                            className="list-inline-item edit"
                                            title="Edit"
                                          >
                                            <Link
                                              to="#"
                                              className="text-primary d-inline-block"
                                              onClick={() => {
                                                setCatName(item.category_name);
                                                setSelectedLocale(item.locale);
                                                setSelectedTranId(item.id);
                                              }}
                                            >
                                              <i className="ri-pencil-fill fs-16"></i>
                                            </Link>
                                          </li>
                                          {/* Delete */}
                                          <li
                                            className="list-inline-item"
                                            title="Delete"
                                          >
                                            <Link
                                              to="#"
                                              className="text-danger d-inline-block"
                                              onClick={() => onDelete(item.id)}
                                            >
                                              <i className="ri-delete-bin-fill fs-16"></i>
                                            </Link>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            )}

                            <FormGroup className="mt-3">
                              <Label for="locale" className="fw-semibold">
                                Locale
                              </Label>
                              <Input
                                id="locale"
                                type="select"
                                value={selectedLocale}
                                onChange={(e) =>
                                  setSelectedLocale(e.target.value)
                                }
                              >
                                <option value="">-- Select Locale --</option>
                                {locale.map((l) => (
                                  <option key={l.id} value={l.name}>
                                    {l.name}
                                  </option>
                                ))}
                              </Input>
                              {translationLocaleError && (
                                <div className="text-danger mt-1">
                                  Locale is required
                                </div>
                              )}
                            </FormGroup>

                            <FormGroup className="mt-3">
                              <Label className="fw-semibold">
                                Category Name
                              </Label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Category Name"
                                value={catName}
                                onChange={(e) => setCatName(e.target.value)}
                              />
                              {catNameError && (
                                <div className="text-danger mt-1">
                                  Category Name is required
                                </div>
                              )}
                            </FormGroup>

                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={saveTranslation}
                            >
                              Save Translation
                            </button>
                          </>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              toggle();
                            }}
                          >
                            {" "}
                            Close{" "}
                          </button>

                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={validation.isSubmitting}
                          >
                            {validation.isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Categories;
